exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width: 768px){\r\n  .login-page {\r\n      margin-top: 50px;\r\n  }\r\n}\r\n@media only screen and (max-width: 991px) {\r\n\r\n\t#top-gap {\r\n    padding-top: 68px;\r\n}}\r\n@media screen and (max-width: 768px){\r\n  .login-page {\r\n      margin-top: 20px;\r\n  }\r\n  .login-body{\r\n    width: 95%;\r\n  }\r\n}\r\n#top-gap {\r\n    padding-top: 134px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/reset-password/reset-password.component.css
// module id = ../../../../../src/app/components/reset-password/reset-password.component.css
// module chunks = main